import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MinMaxValidationHintComponent extends Vue {

    @Prop() public min!: boolean;

    @Prop() public max!: boolean;

    @Prop() public translations!: { [key: string]: string; };
}
